import { get } from 'lodash/fp';

import { TaxRateStrategyCoProduct, TaxRateStrategyDiscriminator } from '@mews-distributor/common';

import { FlatTaxRate } from './FlatTaxRate';
import { RelativeTaxRate } from './RelativeTaxRate';

interface TaxRateProps {
    name: string;
    strategy: TaxRateStrategyCoProduct;
}

const renderTaxRateStrategy = (strategy: TaxRateStrategyCoProduct) => {
    switch (strategy.discriminator) {
        case TaxRateStrategyDiscriminator.Flat:
            return <FlatTaxRate strategy={get('value', strategy)} />;

        case TaxRateStrategyDiscriminator.Relative:
            return <RelativeTaxRate strategy={get('value', strategy)} />;

        default:
            return null;
    }
};

export const TaxRate: React.FC<TaxRateProps> = ({ name, strategy }) => (
    <>
        {`${name} `}
        {renderTaxRateStrategy(strategy)}
    </>
);
